const replacements = [
  // ae -> ligature or umlaut
  { search: 'ae', replacement: '([a\xE0-\xE5][e\xE8-\xEB]|\xE6|\xE4)' },
  // ae ligature
  { search: '\xE6', replacement: '(ae|\xE6)' },
  // oe -> ligature or umlaut
  { search: 'oe', replacement: '([o\xF2-\xF6\xF8][e\xE8-\xEB]|\x153|\xF6)' },
  // oe ligature
  { search: '\x153', replacement: '(oe|\x153)' },
  // ue -> umlaut
  { search: 'ue', replacement: '([u\xF9-\xFC][e\xE8-\xEB]|\xFC)' },
  // ny -> enya
  { search: 'ny', replacement: '(\xF1|n[y\xFD\xFF])' },
  // a umlaut
  { search: '\xE4', replacement: '([a\xE0-\xE5]|ae)' },
  // a - all
  { search: '[a\xE0-\xE5]', replacement: '[a\xE0-\xE5]' },
  // c, cedila
  { search: '[c\xE7]', replacement: '[c\xE7]' },
  // e -all
  { search: '[e\xE8-\xEB]', replacement: '[e\xE8-\xEB]' },
  // i - all
  { search: '[i\xEC-\xEF]', replacement: '[i\xEC-\xEF]' },
  // n -> enya
  { search: 'n', replacement: '[n\xF1]' },
  // enya
  { search: '\xF1', replacement: '(n|\xF1|ny)' },
  // o umlaut
  { search: '\xF6', replacement: '([o\xF2-\xF6\xF8]|oe)' },
  // o - all
  { search: '[o\xF2-\xF5\xF8]', replacement: '[o\xF2-\xF6\xF8]' },
  // u umlaut
  { search: '\xFC', replacement: '([u\xF9-\xFC]|ue)' },
  // u - all
  { search: '[u\xF9-\xFB]', replacement: '[u\xF9-\xFC]' },
  // y - all
  { search: '[y\xFD\xFF]', replacement: '[y\xFD\xFF]' },
];

const searchDiacritics = new RegExp(
  '(?:' + replacements.map((r) => '(' + r.search + ')').join('|') + ')',
  'gi'
);

// Regex is there to escape any regex characters that might be in the terms
// eslint-disable-next-line
const stripRegexChars = /([\\\^\$*+[\]?{}.=!:(|)])/g;

function replaceDiacritics(): any {
  for (let index = 1; index < arguments.length; index++) {
    // eslint-disable-next-line prefer-rest-params
    if (arguments[index]) {
      return replacements[index - 1].replacement;
    }
  }
}

function replaceDiacriticsWithoutSets(): any {
  for (let index = 1; index < arguments.length; index++) {
    // eslint-disable-next-line prefer-rest-params
    if (arguments[index]) {
      return replacements[index - 1].replacement.replace(stripRegexChars, '');
    }
  }
}

export function createSearchRegex(search: string): RegExp {
  search = search.toLowerCase().trim();
  const textSafeForRegex = search.replace(stripRegexChars, '\\$1');
  const searchWithSets = textSafeForRegex.replace(
    searchDiacritics,
    replaceDiacritics
  );
  const searchWithoutSets = textSafeForRegex.replace(
    searchDiacritics,
    replaceDiacriticsWithoutSets
  );

  return new RegExp(
    `^(?:the\\s)?(.{0,}?)((${searchWithSets})|([${searchWithoutSets}]{${Math.ceil(
      search.length / 1.3
    )},}))(.*)$`,
    'i'
  );
}

export function scoreMatch(...matches: (RegExpExecArray | null | undefined)[]) {
  let score = 0;
  for (let i = 0; i < matches.length; i++) {
    const match = matches[i];
    if (match) {
      if (match[3]) {
        // high rank for strict match
        score += 10000;
      }
      // rank for being a primary, secondary, ... etc match
      score += (10 - i) * 100;

      if (match[1]) {
        // reduce for additional preceding chars
        score -= match[1].length;
      } else {
        // increase for no characters at front
        score += 200;
      }
      if (match[5]) {
        // reduce for additional words at back
        score -= match[5].split(/\s+/g).length;
      } else if (!match[1]) {
        // increase for no characters at back and front
        score += 200;
      }
      break;
    }
  }
  return score;
}
